import React from 'react';
import { motion } from 'framer-motion';
import { User, Quote } from 'lucide-react';

const easeLuxury = [0.22, 1, 0.36, 1];

export default function Founder() {
  return (
    <section className="bg-bg-secondary py-20 sm:py-28 lg:py-36 border-y border-border-soft">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-10 sm:gap-16 items-center">
          {/* Photo */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.8, ease: easeLuxury }}
            className="relative"
          >
            <div className="relative aspect-[4/5] max-w-md mx-auto rounded-2xl overflow-hidden border border-accent-gold/30 bg-gradient-to-br from-bg-primary via-[#1a1a1a] to-black flex flex-col items-center justify-center">
              <User className="text-white/15 mb-4" size={64} strokeWidth={1} />
              <p className="text-text-muted text-sm tracking-widest uppercase">Görsel Eklenecek</p>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
            </div>
            <div className="absolute -inset-3 -z-10 rounded-2xl border border-accent-gold/20 max-w-md mx-auto" />
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.8, ease: easeLuxury, delay: 0.1 }}
            className="space-y-6"
          >
            <p className="text-accent-gold font-semibold tracking-[0.3em] uppercase text-sm">Kurucu</p>
            <div>
              <h2 className="text-2xl sm:text-3xl md:text-5xl font-black text-white tracking-tightest">Ali Gedik</h2>
              <p className="text-text-muted font-light mt-2 text-sm sm:text-base">Öncü Boya Kurucusu</p>
            </div>

            <div className="relative pl-6 border-l-2 border-accent-gold">
              <Quote className="absolute -left-3 -top-2 text-accent-gold bg-bg-secondary" size={20} />
              <p className="text-white/90 italic font-light text-base sm:text-lg leading-relaxed">
                "Her aracı kendi aracımız gibi görüyor, işimizi titizlikle ve dürüstlükle yapıyoruz.
                Müşterilerimizin güveni, en büyük sermayemiz."
              </p>
            </div>

            <div className="space-y-4 text-text-muted font-light leading-relaxed max-w-xl text-sm sm:text-base">
              <p>
                Öncü Boya'nın kurucusu Ali Gedik, 1988 yılında Ondokuz Mayıs Üniversitesi Kimya
                Bölümü'nden mezun olmuştur. Kimya alanındaki akademik altyapısını ve yıllar
                boyunca edindiği sektörel tecrübeyi otomotiv boya sektörüne taşıyarak Öncü
                Boya'nın temellerini atmıştır.
              </p>
              <p>
                Meslek hayatı boyunca kalite, güvenilirlik ve müşteri memnuniyetini temel
                prensip olarak benimseyen Ali Gedik, boya teknolojileri ve uygulamaları
                konusundaki bilgi birikimiyle müşterilerine en uygun çözümleri sunmayı
                hedeflemiştir. Teknik uzmanlığını sürekli gelişen sektör ihtiyaçlarıyla
                birleştirerek, profesyonel hizmet anlayışını yıllardır başarıyla sürdürmektedir.
              </p>
              <p>
                Bugün Öncü Boya, Ali Gedik'in bilgi, deneyim ve titiz çalışma anlayışı
                doğrultusunda müşterilerine kaliteli ürünler ve güvenilir hizmet sunmaya devam
                etmektedir. Uzun yıllara dayanan tecrübesiyle sektörde güven duyulan bir isim
                olarak çalışmalarını sürdürmektedir.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
